export default {
  name: 'input_number',
  component_path: 'modules/procedures/blocks/BlockInputNumber'
}